export const CLIENT_PROFILE_PHOTO_MODAL_NAME = 'clientProfilePhoto';
